;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();import {
  POST_HERE_SEARCH_ICON,
  POST_HERE_REFERRAL_ICON,
  POST_HERE_SEATS_ICON,
  POST_HERE_PAYMENTS_ICON,
  POST_HERE_MARKETING_ICON,
  POST_HERE_REACH_ICON,
} from "../../shared/constants"

export const ICON_AND_REASONS = [
  {
    iconType: POST_HERE_SEARCH_ICON,
    title: "Group search-ability",
    description:
      "On this hub dedicated just to mental health groups, people can easily search for the kind of group they’re looking for, all in one browser tab.",
  },
  {
    iconType: POST_HERE_REFERRAL_ICON,
    title: "Broader referrals",
    description:
      "Make it easier for professionals outside of your network to find your group to support their clients on their goals!",
  },
  {
    iconType: POST_HERE_SEATS_ICON,
    title: "Secure seats",
    description:
      "Clients may pay a deposit for their seat upon joining (which you can decline or accept if you require a consultation), enabling you to accurately predict attendance.",
  },
  {
    iconType: POST_HERE_PAYMENTS_ICON,
    title: "Secure payments",
    description:
      "You decide when clients invest (pay upfront or per session) and your clients trust us to hold your payment until service is rendered.",
  },
  {
    iconType: POST_HERE_MARKETING_ICON,
    title: "Marketing",
    description:
      'Our "post a group" flow will lead you through the process of describing & marketing your group. We\'ll help you ensure your concept is ready to share!',
  },
  {
    iconType: POST_HERE_REACH_ICON,
    title: "Expand your reach",
    description:
      "Cast a broader net by being a part of a mental health platform that encourages interdisciplinary collaboration and care.",
  },
]
